<template>
  <div>
    <div>
      <div class="block-story">&ldquo;{{ d.story }}&rdquo;</div>
      <div class="block-meta name">{{ d.name }}</div>
      <div class="block-meta age" v-if="d.age">Age {{ d.age }}</div>
      <div class="block-meta location" v-if="d.location">{{ d.location }}</div>
    </div>
  </div>
</template>

<script>
  module.exports = {
    props: ['d'],
    methods: {
    },
  }
</script>

<style scoped></style>
